import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface OrderHistoryReorderEntityParams {
  distributorId: number;
  orderId: number;
  inventoryId: number;
  productId: number;
  productLineId: number;
}

export class OrderHistoryReorderEntity extends BaseEntityClass {
  distributorId: number;
  orderId: number;
  inventoryId: number;
  productId: number;
  productLineId: number;
  constructor(params: OrderHistoryReorderEntityParams) {
    super();
    this.type = "order_history_reorder";
    this.entity_version = 2;
    this.distributorId = params.distributorId;
    this.orderId = params.orderId;
    this.inventoryId = params.inventoryId;
    this.productId = params.productId;
    this.productLineId = params.productLineId;
  }
}
